import AuthLayout from "@container/layout/auth";
import AgentSettingsContainer from "@container/agent-settings";

export default function AgentSettingsPage() {
    return (
        <AuthLayout>
            <AgentSettingsContainer />
        </AuthLayout>
    );
}
